import EventEmitter from 'src/utils/EventEmitter';

export const CheckExpiredToken = (error_message) => {
  var is_token_expired = false;
  if (error_message) {
    if (error_message.includes("The token is expired") || error_message.includes("code 401")) {
      EventEmitter.emit("token_expired", { value: true })
      is_token_expired = true;
    }
  }

  return is_token_expired;
}